export const initManufacturingBom = (bom = {}) => ({
    ...bom,

    ROW_NUM: bom?.ROW_NUM || null,
    ECO_NO: bom?.ECO_NO || null,
    ECO_TYPE_NAME: bom?.ECO_TYPE_NAME || null,
    ECO_FLAG_NAME: bom?.ECO_FLAG_NAME || null,
    ECO_DATE: bom?.ECO_DATE || null,
    DATE_FR: bom?.DATE_FR || null,
    DATE_TO: bom?.DATE_TO || null,
    MODEL_CODE: bom?.MODEL_CODE || null,
    MODEL_NAME: bom?.MODEL_NAME || null,
    REVISION: bom?.REVISION || null,
    RANK: bom?.RANK || null,
    MODEL_CODE_FR: bom?.MODEL_CODE_FR || null,
    MODEL_NAME_FR: bom?.MODEL_NAME_FR || null,
    REVISION_FR: bom?.REVISION_FR || null,
    RANK_FR: bom?.RANK_FR || null,
    PRECISION_YN: bom?.PRECISION_YN || null,
    PBOM_YN: bom?.PBOM_YN || null,
    ECO_REASON: bom?.ECO_REASON || null,
    ECO_DETAIL: bom?.ECO_DETAIL || null,
    ECO_TYPE: bom?.ECO_TYPE || null,
    ECO_FLAG: bom?.ECO_FLAG || null,
    UPDATE_DATE: bom?.UPDATE_DATE || null,
});

export const initManufacturingBomRow = (row = {}) => ({
    ...row,

    ROW_NUM: row?.ROW_NUM || null,
    BOM_LEVEL: row?.BOM_LEVEL || null,
    ITEM_LEVEL: row?.ITEM_LEVEL || null,
    WORK_TYPE: row?.WORK_TYPE || null,
    ITEMSEQ: row?.ITEMSEQ || null,
    ITEM_CODE_P: row?.ITEM_CODE_P || null,
    ITEM_FLAG: row?.ITEM_FLAG || null,
    ITEM_NAME: row?.ITEM_NAME || null,
    ITEM_CODE: row?.ITEM_CODE || null,
    ITEM_NO: row?.ITEM_NO || null,
    CLASS_CODE: row?.CLASS_CODE || null,
    CLASS_NAME: row?.CLASS_NAME || null,
    ITEM_TYPE: row?.ITEM_TYPE || null,
    ITEM_TYPE_NAME: row?.ITEM_TYPE_NAME || null,
    REVISION: row?.REVISION || null,
    RANK: row?.RANK || null,
    CIRCUIT_NO: row?.CIRCUIT_NO || null,
    UNIT_QTY: row?.UNIT_QTY || null,
    CREATE_DATE: row?.CREATE_DATE || null,
    MAKER_PARTNO: row?.MAKER_PARTNO || null,
    SPEC: row?.SPEC || null,
    MAKER_NAME: row?.MAKER_NAME || null,
    SUPPLIER_NAME: row?.SUPPLIER_NAME || null,
    ATTRIBUTE08: row?.ATTRIBUTE08 || null,
    ATTRIBUTE09: row?.ATTRIBUTE09 || null,
    ATTRIBUTE10: row?.ATTRIBUTE10 || null,
    DATE_FR: row?.DATE_FR || null,
    DATE_TO: row?.DATE_TO || null,
    WORK_SIDE: row?.WORK_SIDE || null,
    X_POS: row?.X_POS || null,
    Y_POS: row?.Y_POS || null,
    ANGLE: row?.ANGLE || null,
});
